export const AUTOSAVE_INTERVAL_MS = 1000
